import * as React from "react";
import { Affix } from "../affix/affix.mjs";
import { Container } from "../container/container.mjs";
import { ContentTable } from "./content-table.mjs";
import { HeaderTable } from "./header-table.mjs";
const DesktopComparison = (props) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Affix, { className: "product-comparison__affix" }, /* @__PURE__ */ React.createElement("div", { className: "product-comparison__wrapper" }, /* @__PURE__ */ React.createElement(Container, { className: "product-comparison__container" }, /* @__PURE__ */ React.createElement(
    HeaderTable,
    {
      deviceLabel: props.deviceLabel,
      placeholder: props.placeholder,
      items: props.items,
      title: props.title,
      compareCheckLabel: props.compareCheckLabel,
      isCompareChecked: props.isCompareChecked,
      onCompareCheckChange: props.onCompareCheckChange
    }
  )))), /* @__PURE__ */ React.createElement(Container, { className: "product-comparison__content-wrapper" }, props.categories.map((category) => {
    return /* @__PURE__ */ React.createElement(ContentTable, { key: category.id, category, label: category.label, items: props.items, deviceLabel: props.deviceLabel });
  })));
};
export {
  DesktopComparison
};
